import {
  LetterbookOwnerType,
  LetterbookSettingType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import { BookButton } from "features/BookButton";
import LetterbookCell from "../LetterbookCell";

export default function BookButtonColumn({
  letterbook,
  settings,
}: {
  letterbook: LetterbookOwnerType;
  settings: LetterbookSettingType;
}) {
  return (
    <LetterbookCell>
      <BookButton
        bookId={letterbook.book.id}
        referrerUserId={settings.conditions.referrer_id}
      />
    </LetterbookCell>
  );
}

export const settings = {
  key: "BookButton",
  title: "Controls",
} as LetterlistTableColumnSettingType;
